import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
} from "@chakra-ui/react";
import styled from "@emotion/styled";
import { useRouter } from "next/router";
import { ReactNode } from "react-markdown/lib/react-markdown";
import { useRecoilState } from "recoil";
import { UserCustomCopyTemplates } from "../../atoms/UserAtom";
import { ICustomCopyTemplates } from "../../types/UserTypes";

import StyledButton from "../StyledButton";

const PopoverTitle = styled.div`
  color: #888888;
  font-size: 14px;
  font-weight: 400;

  padding: 8px;

  text-transform: uppercase;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  font-size: 16px;
  font-weight: 400;
  color: #2f2f2f;
  cursor: pointer;

  &:hover {
    background-color: #fb972e;
    color: #ffffff;
    border-radius: 5px;
  }
`;

const ErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  grid-gap: 8px;

  button {
    width: 100%;
  }
`;

const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  font-size: 16px;
  font-weight: 400;
  font-style: italic;
  color: #2f2f2f;
`;

interface CustomCopyTemplatesPopoverProps {
  children: ReactNode | JSX.Element;
  isOpen: boolean;
  onClose: () => void;
  templateCopyArray: ICustomCopyTemplates[];
  onSelected: (selectedCustomCopy: ICustomCopyTemplates) => void;
}

export default function CustomCopyTemplatesPopover(
  props: CustomCopyTemplatesPopoverProps
) {
  return (
    <Popover
      closeOnEsc
      closeOnBlur
      placement="bottom-start"
      isOpen={props.isOpen}
      onClose={props.onClose}
    >
      <PopoverTrigger>{props.children}</PopoverTrigger>
      <PopoverContent p="8px" w="240px">
        <PopoverArrow />
        <PopoverBody p={0}>
          <PopoverTitle>Custom Copy Templates</PopoverTitle>
          {props.templateCopyArray.length > 0 &&
            props.templateCopyArray.map((item) => (
              <Row
                key={item.title}
                onClick={() => {
                  props.onSelected(item);
                  props.onClose();
                }}
              >
                {item.title}
              </Row>
            ))}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
